module.exports = __webpack_public_path__ + "img/yasnateam-logo.20db17dc.png";